{
  "emailSlugLabel": "Slug e-mail",
  "tabs": {
    "authorizedAccounts": "Comptes autorisés",
    "fbos": "FBOs",
    "users": "Membres",
    "faaMapping": "Liaison FAA",
    "announcements": "Annonces",
    "activity": "Activité",
    "movableObstacles": "Obstacles mobiles",
    "towingEquipment": "Équipement de remorquage",
    "aircraft": "Aéronef",
    "labeling": "Étiquetage",
    "convertSvgs": "Convertir les SVG",
    "systemStatus": "État du système",
    "quarantine": "Quarantaine",
    "activation": "Activation"
  },
  "uberAdmin": {
    "renderJobHistory": {
      "title": "Historique des rendus",
      "description": "Tâches récentes de Render (update-aircraft, movable obstacles, towing equipment). Actualisation automatique toutes les 20 secondes.",
      "tooltips": {
        "forceRun": "« Forcer l'exécution » réinitialise la somme de contrôle et exécute la tâche même si les données n'ont pas changé. Utile pour les tests ou pour s'assurer que toutes les bases de données sont synchronisées.",
        "refreshing": "Actualisation des tâches..."
      },
      "buttons": {
        "forceRun": "Forcer",
        "running": "Chargement..."
      },
      "columns": {
        "jobType": "Type",
        "status": "Statut",
        "created": "Créé",
        "duration": "Durée",
        "dashboard": "Tableau bord"
      },
      "jobTypes": {
        "updateAircraft": "Modifier l'aéronef",
        "updateMovableObstacles": "Modifier les obstacles mobiles",
        "updateTowingEquipment": "Modifier équipement remorquage"
      },
      "links": {
        "view": "Voir"
      }
    },
    "errorBoundary": {
      "title": "Un problème est survenu",
      "description": "Une erreur s'est produite lors du chargement de cette section. Veuillez actualiser la page."
    },
    "aircraftLastUpdated": {
      "columns": {
        "checksum": "Checksum",
        "lastUpdated": "Mis à jour le",
        "tableName": "Nom de la table"
      },
      "description": "Description",
      "notAvailable": "Non disponible",
      "title": "Aéronef mis à jour le"
    },
    "workerStatus": {
      "columns": {
        "lastChecked": "Dern. vérification",
        "status": "Statut",
        "worker": "Opérateur"
      },
      "description": "Description",
      "notAvailable": "Non disponible",
      "title": "Statut du personnel"
    }
  },
  "components": {
    "aircraftTable": {
      "searchPlaceholder": "Rechercher un aéronef...",
      "headers": {
        "make": "Créer",
        "model": "Modèle",
        "length": "Longueur",
        "wingspan": "Envergure",
        "tailHeight": "Hauteur de queue",
        "status": "Statut"
      },
      "status": {
        "deployed": "Déployé",
        "labeling": "Étiquetage",
        "locked": "Verrouillé"
      }
    }
  },
  "announcementsAdmin": {
    "dialogTitle": {
      "new": "Nouvelle annonce",
      "edit": "Modifier l'annonce"
    },
    "labels": {
      "title": "Titre",
      "body": "Corps",
      "mediaType": "Type de média",
      "youtubeEmbed": "Code d'intégration YouTube",
      "uploadImage": "Ajouter l'image",
      "changeImage": "Modifier l'image",
      "actionLink": "Lien d'action (facultatif)",
      "linkButtonText": "Texte du bouton lien (facultatif)",
      "expirationDate": "Date d'expiration"
    },
    "helperText": {
      "youtubeEmbed": "Collez le code d'intégration iframe depuis YouTube",
      "actionLink": "Entrez une URL pour ajouter un lien cliquable à l'annonce",
      "linkButtonText": "Par défaut : « En savoir plus »"
    },
    "placeholders": {
      "actionLink": "https://example.com",
      "linkButtonText": "En savoir plus"
    },
    "preview": {
      "expires": "Expiration :"
    },
    "errors": {
      "titleRequired": "Le titre est requis",
      "bodyRequired": "Le contenu est requis",
      "expirationRequired": "La date d'expiration est requise",
      "invalidYouTube": "Veuillez entrer un code d'intégration iframe YouTube valide",
      "videoUrlRequired": "L'URL de la vidéo est requise lorsqu'une vidéo est sélectionnée",
      "imageRequired": "Veuillez téléverser une image",
      "invalidUrl": "Veuillez entrer une URL valide (ex. : https://example.com)",
      "saveFailed": "Échec de l'enregistrement de l'annonce. Veuillez réessayer."
    },
    "confirmDelete": "Voulez-vous vraiment supprimer cette annonce ?",
    "buttons": {
      "create": "Créer",
      "update": "Modifier",
      "uploading": "Téléchargement...",
      "cancel": "Annuler",
      "addAnnouncement": "Ajouter une annonce",
      "preview": "Aperçu",
      "edit": "Édit.",
      "delete": "Supprimer",
      "close": "Fermer"
    },
    "columns": {
      "title": "Titre",
      "body": "Corps",
      "media": "Médias",
      "link": "Lien",
      "status": "Statut",
      "expires": "Expire",
      "actions": "Actions"
    },
    "status": {
      "active": "Actif",
      "expired": "Expiré"
    },
    "mediaTypes": {
      "none": "Aucun",
      "image": "Image",
      "video": "Vidéo"
    }
  },
  "quarantineTab": {
    "title": "Locataires en attente (Quarantaine)",
    "description": "Appareils qui n'ont pas pu être associés au registre FAA ou à la bibliothèque d'appareils lors de l'importation de données. Sélectionnez un appareil pour l'associer directement, ou utilisez « Supprimer et réessayer » pour effacer et attendre la prochaine synchronisation.",
    "successMessage": "Aucun locataire en attente - tous les aéronefs importés ont été associés avec succès !",
    "buttons": {
      "refresh": "Actualiser",
      "removeAndRetry": "Supprimer et réessayer ({{count}})"
    },
    "tableHeaders": {
      "tailNumber": "Immatriculation",
      "fbo": "FBO",
      "typeHint": "Type d'indice",
      "mapToAircraft": "Associer à l'aéronef",
      "register": "S'inscrire",
      "source": "Source",
      "created": "Créé"
    },
    "tooltips": {
      "registerExplainer": "Enregistrer l'immatriculation dans la base FAA. Décochez pour les immatriculations provisoires ou de devis.",
      "willAddToFaa": "Sera ajouté à la base de données FAA",
      "quotePlaceholder": "Devis/exemple - n'affectera pas la base de données FAA",
      "placeholderWarning": "Semble être une immatriculation provisoire - ne sera pas ajoutée à la base FAA sauf si cochée"
    },
    "table": {
      "noPendingTenants": "Aucun locataire en attente",
      "mapping": "Mappage...",
      "selectAircraft": "Sélectionner l'aéronef"
    },
    "defaults": {
      "unknownFbo": "FBO inconnu",
      "unknownOperator": "Inconnu",
      "unknownTypeHint": "Inconnu"
    },
    "dialog": {
      "title": "Supprimer en attente et réessayer",
      "description": "Retirer {{count}} locataire(s) en attente de la file d'attente de quarantaine.",
      "autoRetryTitle": "Réessai auto :",
      "autoRetryBody": "La prochaine synchronisation de données planifiée (toutes les 5 minutes) tentera automatiquement de recréer ces locataires. Si vous avez corrigé le mapping FAA (ajouté l'aéronef à la bibliothèque ou mis à jour la table faa_to_airplx), le locataire sera créé avec succès.",
      "retryNote": "Si le mapping est toujours manquant, le tenant sera remis en quarantaine. Vous pourrez alors corriger le mapping et réessayer.",
      "cancelButton": "Annuler",
      "confirmButton": "Supprimer et réessayer au prochain sync",
      "removing": "Suppression..."
    },
    "snackbar": {
      "removed": "Supprimé {{count}} locataire(s) en attente",
      "mapFailed": "Échec du mappage de l'appareil"
    },
    "pendingCount": "Nombre en attente",
    "selectionCount": "Nombre de sélections"
  },
  "aircraftAdmin": {
    "title": "Base de données aéronefs",
    "loading": "Chargement des données aéronef...",
    "status": {
      "locked": "Verrouillé",
      "deployed": "Déployé",
      "labeling": "Étiquetage"
    },
    "exportHeaders": {
      "make": "Créer",
      "model": "Modèle",
      "length": "Longueur",
      "wingspan": "Envergure",
      "tailHeight": "Hauteur de queue",
      "status": "Statut",
      "id": "ID"
    },
    "aircraftDeployed": "Aéronefs déployés : <strong>{{count}}</strong>",
    "exportButton": "Exporter la liste des aéronefs"
  },
  "aircraftPreview": {
    "selectPrompt": "Sélectionnez un aéronef pour prévisualiser",
    "noImage": "Aucune image disponible",
    "editButton": "Édit.",
    "fields": {
      "id": "ID :",
      "length": "Longueur :",
      "wingspan": "Envergure :",
      "tailHeight": "Hauteur de queue :",
      "linkedTo": "Lié à :"
    }
  },
  "flightBridgeStatus": {
    "title": "Intégrations FlightBridge",
    "description": "FlightBridge synchronise les plannings de vols et les réservations conciergerie depuis les systèmes externes de gestion des opérations aériennes. Chaque intégration FBO se synchronise de manière incrémentale via des webhooks et des mises à jour planifiées.",
    "columns": {
      "fbo": "FBO",
      "companyId": "ID entreprise",
      "status": "Statut",
      "lastSync": "Dern. sync.",
      "error": "Erreur"
    },
    "never": "Jamais"
  },
  "recentActivity": {
    "noActivity": "Aucune activité récente",
    "columns": {
      "user": "Util.",
      "fbo": "FBO",
      "timestamp": "Horodatage"
    }
  },
  "weeklyActivityTable": {
    "title": "Activité hebdomadaire",
    "noData": "Aucune donnée d'activité disponible pour la période sélectionnée.",
    "exportButton": "Exporter TSV",
    "showTestFBOs": "FBO de test",
    "columns": {
      "fbo": "FBO"
    },
    "metrics": {
      "totalCustomers": "Clients au total",
      "weeklyActive": "Actifs/semaine",
      "monthlyActive": "Actifs mensuels"
    },
    "footer": {
      "totalFBOs": "Total FBO :"
    }
  },
  "superUserAdmin": {
    "loading": "Chargement...",
    "columns": {
      "userId": "ID utilis.",
      "name": "Nom",
      "email": "E-mail",
      "fbo": "FBO",
      "action": "Action",
      "permissions": "Autorisations"
    },
    "placeholders": {
      "none": "---",
      "searchUser": "Rechercher utilisateur",
      "searchFBO": "Rechercher un FBO"
    },
    "buttons": {
      "edit": "Modif.",
      "close": "Fermer",
      "save": "Enregistrer",
      "saving": "Enregistr..."
    },
    "roles": {
      "none": "Aucun"
    },
    "moreChip": "+ {{count}} autre(s)",
    "dialog": {
      "title": "Modifier"
    }
  },
  "buttonRemoveFBO": {
    "button": "Retirer FBO",
    "dialog": {
      "title": "Supprimer le FBO ?",
      "message": "Voulez-vous vraiment supprimer ce FBO ? Cette action est irréversible.",
      "cancelButton": "Annuler",
      "confirmButton": "Confirmer"
    }
  },
  "towingEquipmentAdmin": {
    "loading": "Chargement équipement remorquage...",
    "buttons": {
      "addEquipment": "Ajouter équipement",
      "exportList": "Exporter les équipements",
      "deploy": "Déployer"
    },
    "tooltips": {
      "deployOnlyProduction": "Le déploiement est disponible uniquement en production (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "Voulez-vous vraiment supprimer « {{name}} » ?",
      "deployTitle": "Confirmer déploiement",
      "deployMessage": "Voulez-vous vraiment déployer les mises à jour des équipements de remorquage ?",
      "deployOkButton": "C'est parti !"
    },
    "errors": {
      "deleteFailed": "Échec de la suppression de l'équipement : {{error}}",
      "nameRequired": "Veuillez indiquer un nom pour l'équipement.",
      "invalidDimensions": "Veuillez fournir des valeurs valides pour tous les champs de dimensions. Les dimensions doivent être des nombres positifs jusqu'à 1000 pieds.",
      "createFailed": "Échec de la création de l'équipement. Veuillez réessayer.",
      "saveFailed": "Erreur d'enregistrement : {{error}}",
      "widthInvalid": "La largeur doit être un nombre positif jusqu'à 1000 pieds.",
      "lengthInvalid": "La longueur doit être un nombre positif jusqu'à 1000 pieds.",
      "heightInvalid": "La hauteur doit être un nombre positif jusqu'à 1000 pieds."
    },
    "exportHeaders": {
      "name": "Nom",
      "width": "Largeur",
      "length": "Longueur",
      "height": "Hauteur",
      "towBarLength": "Longueur barre",
      "id": "ID"
    }
  },
  "movableObstacleAdmin": {
    "loading": "Chargement des obstacles...",
    "buttons": {
      "addObstacle": "Ajouter obstacle",
      "exportList": "Exporter les obstacles",
      "deploy": "Déployer"
    },
    "tooltips": {
      "deployOnlyProduction": "Le déploiement est disponible uniquement en production (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "Voulez-vous vraiment supprimer « {{name}} » ?",
      "deployTitle": "Confirmer déploiement",
      "deployMessage": "Voulez-vous vraiment déployer ?",
      "deployOkButton": "C'est parti !"
    },
    "errors": {
      "deleteFailed": "Échec de la suppression de l'obstacle : {{error}}",
      "invalidDimensions": "Veuillez fournir des valeurs valides pour tous les champs. Les dimensions doivent être des nombres positifs jusqu'à 1000 pieds.",
      "createFailed": "Échec de la création de l'obstacle. Veuillez réessayer.",
      "saveFailed": "Échec de l'enregistrement de l'obstacle : {{error}}",
      "widthInvalid": "La largeur doit être un nombre positif jusqu'à 1000 pieds.",
      "lengthInvalid": "La longueur doit être un nombre positif jusqu'à 1000 pieds.",
      "heightInvalid": "La hauteur doit être un nombre positif jusqu'à 1000 pieds."
    },
    "exportHeaders": {
      "name": "Nom",
      "width": "Largeur",
      "length": "Longueur",
      "height": "Hauteur",
      "id": "ID"
    }
  },
  "aircraftMappingTab": {
    "coverage": "Couverture : {{percentage}} % ({{mappedTails}} / {{totalTails}})",
    "searchPlaceholder": "Rechercher par fabricant ou modèle FAA",
    "filters": {
      "manufacturer": "Constructeur",
      "country": "Pays",
      "allCountries": "Tout",
      "unmatched": "Non associé",
      "withSuggestions": "Avec suggestions"
    },
    "tableHeaders": {
      "frequency": "Fréquence",
      "faaManufacturer": "Constructeur FAA",
      "faaModel": "Modèle FAA",
      "airplxAircraft": "AirPlx Aircraft"
    },
    "tooltips": {
      "frequencyAllCountries": "Nombre total d'immatriculations enregistrées pour ce type d'aéronef",
      "frequencyWithCountry": "Format : « countryCount (totalCount) » - Affiche les immatriculations {{country}} avec le total mondial entre parenthèses. Trié par nombre {{country}}.",
      "blacklist": "Bloquer ce type FAA (drones, ballons, etc.)"
    },
    "snackbar": {
      "blacklisted": "\"{{manufacturer}} {{model}}\" sur liste noire",
      "blacklistFailed": "Échec de l'ajout à la liste noire. Veuillez réessayer.",
      "bulkApplySuccess": "Appliqué {{appliedCount}} correspondances ({{skippedCount}} ignorées)",
      "bulkApplyFailed": "Application groupée échouée : {{message}}",
      "reApplySuccess": "Motif « {{query}} » réappliqué : {{appliedCount}} correspondances ({{skippedCount}} ignorées)",
      "reApplyFailed": "Échec de la réapplication : {{message}}",
      "patternDeleted": "Modèle supprimé",
      "patternDeleteFailed": "Échec de la suppression : {{message}}"
    }
  },
  "activation": {
    "overview": {
      "title": "Activation des utilisateurs",
      "description": "Suivez et gérez la progression d'activation des utilisateurs dans les FBO",
      "filterLabel": "Filtrer",
      "noData": "Aucun enregistrement d'activation trouvé",
      "viewDetails": "Voir les détails",
      "columns": {
        "user": "User",
        "fboName": "FBO",
        "state": "État",
        "autostackRuns": "Exécutions AutoStack",
        "checklist": "Checklist",
        "timeline": "Chronologie",
        "mode": "Afficher checklist",
        "actions": "Actions"
      },
      "states": {
        "pre": "Pré-activation",
        "shallow": "Faible",
        "deep": "Prof."
      },
      "filters": {
        "all": "Tous",
        "active": "Actifs seuls",
        "stalled": "Bloqué",
        "deep": "Activation profonde"
      },
      "fboFilter": "FBO",
      "allFbos": "Tous les FBO",
      "searchPlaceholder": "Rechercher par nom ou e-mail"
    },
    "detail": {
      "title": "Détails d'activation",
      "userInfo": "Informations utilisateur",
      "checklistProgress": "Progression de la checklist",
      "adminControls": "Administration",
      "auditLog": "Historique",
      "notes": "Notes internes",
      "reason": "Motif de la modification",
      "reasonHelp": "Note facultative pour le journal d'audit",
      "notCompleted": "Non terminé",
      "markComplete": "Marquer terminé",
      "uncheckStep": "Réinitialiser l'étape (décocher)",
      "controls": {
        "startDate": {
          "label": "Activation démarrée",
          "help": "Ajuster pour les corrections de période d'essai",
          "update": "Mettre à jour"
        },
        "windowDays": {
          "label": "Fenêtre d'activation (jours)",
          "help": "Prolonger ou raccourcir la période d'activation"
        },
        "threshold": {
          "label": "Seuil d'activation profonde",
          "help": "Combien d'exécutions AutoStack = activation approfondie"
        },
        "variant": {
          "label": "Style de checklist",
          "help": "Variante d'interface à afficher",
          "options": {
            "sidebar": "Panneau latéral",
            "floating": "Carte flottante",
            "banner": "Bandeau haut"
          }
        },
        "forceDeep": {
          "label": "Forcer l'activation profonde",
          "help": "Marquer manuellement comme profondément activé (rare)"
        }
      }
    }
  }
}
